import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faLock, faArrowRightFromBracket, faUser } from "@fortawesome/free-solid-svg-icons";
import { useLayout } from "@/contexts/LayoutContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/shadcn/dropdown-menu";
import { popupCenter } from "@/utils/popup";

export const UserMenu = () => {
  const { data } = useLayout();
  const routes = data.appRoutes;
  const showSettings = data.visibleMaintenanceAreas.includes("UserSettings");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center justify-center w-8 h-8 text-white hover:opacity-85 rounded-full transition-opacity focus:outline-none font-semibold shrink-0"
          style={data.customerMode ? { backgroundColor: "#757575", fontSize: 13 } : { backgroundColor: data.userAvatarColor, fontSize: 13 }}
          aria-label="User menu"
        >
          {data.customerMode
            ? <FontAwesomeIcon icon={faEye} size="sm" />
            : data.userInitials}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-45">
        <DropdownMenuLabel>{data.username}</DropdownMenuLabel>
        {showSettings && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => popupCenter(routes.userPreferences, "UserPreferences", 1024, 768)}>
              <FontAwesomeIcon icon={faUser} className="mr-2" />
              My Preferences
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <a href={routes.accountSettings}>
                <FontAwesomeIcon icon={faLock} className="mr-2" />
                My Account
              </a>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild >
          <a href={routes.logout}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} className="mr-2" />
            Logout
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
